import React from 'react';
import PropTypes from 'prop-types';
import InputAdapter from "./InputAdapter";

const LoginField = (props) => {
	return <InputAdapter
		{...props}
		inputType={`text`}
		inputClass="input-login"
	/>;
};

LoginField.propTypes = {
	align: PropTypes.string,
	columnsSmall: PropTypes.number,
	columnsMedium: PropTypes.number,
	columnsLarge: PropTypes.number,
	disabled: PropTypes.bool,
	elementEditBar: PropTypes.object,
	error: PropTypes.string,
	label: PropTypes.string.isRequired,
	labelClass: PropTypes.string,
	name: PropTypes.string.isRequired,
	onChange: PropTypes.func,
	showLabel: PropTypes.bool,
	value: PropTypes.string,
	wrapperClass: PropTypes.string,
};

export default LoginField;